var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"platform flex"},[_c('div',{staticClass:"logo flex"},[(_vm.platform.image)?_c('b-img',{attrs:{"src":_vm.getImageURLByType(_vm.platform.image.File, 0, 'PLATFORM'),"fluid":"","alt":_vm.platform.abbr,"height":"12px"}}):_vm._e()],1),(!_vm.iconOnly)?_c('span',[_vm._v(" "+_vm._s(_vm.platform[_vm.field]))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }